import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import queryString from 'query-string';
const RazorpayAPIKey ="rzp_live_gqN0HLYx3a5HsE";
const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'SUCCESS', value: 'SUCCESS' },
    { key: 'FAILED', value: 'FAILED' },
]
const searchBy = [
    { key: 'Amount', value: 'amount' },
    { key: 'Transaction Date', value: 'Date' },
    { key: 'Transaction ID', value: 'orderId' },
    { key: 'Status', value: 'status' }
];

function getColumns() {
    let columns = [
        {
            title: 'Amount',
            field: 'amount',
            render: (item) => (
            <div>
            {item.type =='Credit' &&<span style={{color:"green"}}>+₹</span>}
            {item.type =='Debit' &&<span style={{color:"red"}}>-₹</span>}
            {parseFloat(item.amount).toFixed(2)}</div>),
            width: "10%"
            
        },
        //{ title: 'Transaction Type', field: 'type' },
        { title: 'Source', field: 'Source', render: (item) => (
            <div>
            {item['Source'].indexOf("Link")==0 ? (
            <span style={{color:"blue"}}>
                <NavLink exact to={{pathname: ROUTES.PaymentLinks, linkId: item['linkId']}}>
                {item['Source']} 
                    </NavLink>
                </span>
            ):(<span>{item['Source']}</span>)}
             ({item['Provider']?item['Provider']:'CashFree'})
            </div>),
        },
        { title: 'Payment Date', field: 'Date' ,render: (item) => getFormattedDateTime(item.Date)},
        { title: 'Transaction ID', field: 'orderId' },
        { title: 'Description', field: 'Description' },
        { title: 'Status', field: 'status' },
        {
            title: 'Closing Balance',
            field: 'closingBalance',
            render: (item) => (
            <div>
            {item.closingBalance &&<span>₹
            {parseFloat(item.closingBalance).toFixed(2)}</span>}
            </div>),
            
            
        }
    ];

    return columns;
}
function getSource(item) {
    if(item['Source'].indexOf("Link")){
    return '<a>'+ item['Source']+'</a>';
    }else{
    return item['Source'];
    }
    
}


function getEarning(item) {
    if(item['type'] == 'Credit'){
    return '<span>+</span> ₹' + parseFloat(item['amount']).toFixed(2)+'';
    }else if(item['type'] == 'Debit'){
    return '<span>-</span> ₹' + parseFloat(item['amount']).toFixed(2);
    }else{
    return '₹' + parseFloat(item['amount']).toFixed(2);
    }
    
}
function getLinksColumns() {
    let columns = [
        {
            title: 'Link Amount (₹)',
            field: 'linkAmount',
            render: (item) => getLinkAmount(item['linkAmount'])
        },
        {
            title: 'Paid Amount (₹)',
            field: 'amount',
            render: (item) => getLinkAmount(item['amount'])
        },
        { title: 'Link URL', field: 'linkURL' },
        { title: 'Last Paid', field: 'Updated' },
        { title: 'Created', field: 'Date' }
    ];
    return columns;
}

function getLinkAmount(itemAmount) {
    return '₹' + parseFloat(itemAmount).toFixed(2);
}

// const options = ['Option 1', 'Option 2'];

class TransactionHistory extends React.Component {
    _isMounted = false;

    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        isLastPage:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'amount',
        loading: false,

        alert: 0,
        alertMessage: '',
        storeTag: '',
        backArrow: false,
        flag: 0,
        data: [],
        dataLinks: [],
        options: [],
        currentTotalBalance: 0,
        SelectedAccountNumber: '',
        withdrawAmount: '',
        addAmount: '',
        provider:'',
        providerOptions:[],
        
        method:'',
        orderNote: '',
        remarks: '',
        Beneficiary: [],
        benfList: [],
        ShowFlashMessage: false,
        FlashMessage: '',
        commission:0,
        card : 0,
		netbanking:0,
		wallet:0,
		emi:0,
		upi:0,
        paylater:0,
        virtualAccounts:[]

    };

    dataArray = [];
    
    async loadScript(){
        const script = document.createElement("script");
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        document.body.appendChild(script);

    } 

    async loadPaymentGateway() {
        await RestServices.GlobalGet(
            localStorage.getItem('FirebaseToken'),
            'configuration/GetAllPaymentGateway?status=active'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({ alert: 1, alertMessage: responseData.error });
                    }
                } else {
                
                    this.setState({ 
                    loading: false,
                    providerOptions : responseData.data
                    });
                
                
                   
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async componentDidMount() {
        this.loadScript();
        this._isMounted = true;
        this.loadData();
        this.getAssignedVA()
        this.loadPaymentGateway()
        
    }


    
    componentWillUnmount() {
        this._isMounted = false;
    }

    async getAssignedVA(){
        let bodydata = {
            UniqeID: this.props.user.ProfileUniqeID,
            userRole: this.props.role,
        };
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodydata,
            'profiles/getVirtualAccounts'
        ).then((response) => response.json())
            .then((responseData) => {
                
                let IFSC='';
                let AccountNumber='';
                let UPIAddress='';
                let QRCode='';
                

                if(responseData.VirtualAccounts){
                    let VirtualAccounts =responseData.VirtualAccounts
    
                    if(VirtualAccounts && VirtualAccounts['receivers']){
                        let VirtualAccountsArray = VirtualAccounts['receivers']
                        for (var i=0;i<VirtualAccountsArray.length;i++){   
                        if(VirtualAccountsArray[i].ifsc){
                            IFSC = VirtualAccountsArray[i].ifsc
                        }
                        if(VirtualAccountsArray[i].account_number){
                            AccountNumber = VirtualAccountsArray[i].account_number
                        }
                        if(VirtualAccountsArray[i].address){
                            UPIAddress = VirtualAccountsArray[i].address
                        }
                        }
                    }
                }

                if (this._isMounted) {
                    this.setState({ virtualAccounts: {IFSC:IFSC,AccountNumber:AccountNumber,UPIAddress:UPIAddress,QRCode:QRCode} });
                }
                
            })

    }

    

    

    async updateCashFreeWallet(bodyData, reload = false) {
        await RestServices.updateCashFreeWallet(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.status == 'SUCCESS') {
                    if (reload) {
                        this.relaodData();
                    }
                } else {
                    this.relaodData();
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 4,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    async relaodData() {
        if (this._isMounted) {
            this.setState({
                loading: true
            });
        }

        let bodyData = {
            ProfileUniqeID: this.props.user.ProfileUniqeID,
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        let currentTotalBalance = 0;
        await RestServices.getAllCashFreeTransaction(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
               
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                if(responseData.list.length>0){
                   
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.list.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            currentTotalBalance: responseData.walletbalance,
                            data: responseData.list,
                            alert: 0,
                            loading: false
                        });
                    }
                    
                    }else{
                    if (this._isMounted) {
                        this.setState({
                            data: [], 
                            isLastPage: true,
                            alert: 0,
                            loading: false
                        });
                    }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        data: [],
                        loading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginatePrev = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
    this.setState({ search_key: '' }); 
    if(event.target.type === 'number' ){
		if (Number.isNaN(Number.parseFloat(event.target.value))) {
		}else{
		 this.setState({ [event.target.name]: parseFloat(event.target.value) });
		}
    }else{
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
        
    }
    if(event.target.name == 'method'){
        let commission=0;
    if(event.target.value ==='card'){
        commission = this.state.card;
       }else if(event.target.value ==='netbanking'){
        commission = this.state.netbanking;
       }else if(event.target.value ==='wallet'){
        commission = this.state.wallet
       }else if(event.target.value ==='emi'){
        commission = this.state.emi
       }else if(event.target.value ==='upi'){
        commission = this.state.upi
       }else if(event.target.value ==='paylater'){
        commission = this.state.paylater
       }
       this.setState({ commission: commission });
    }
    
    if(event.target.name == 'provider' ){
      if(event.target.value) {
        let seelctprovider = this.state.providerOptions.filter(value=>value.title==event.target.value)[0]
        /*
        if(event.target.value =='CashFree'){
        this.setState({ commission: this.state.upi });
        this.setState({ method: 'upi' });
        }
*/
        this.setState({ 
                    card : seelctprovider.card,
				    netbanking:seelctprovider.netbanking,
				    wallet:seelctprovider.wallet,
				    emi:seelctprovider.emi,
				    upi:seelctprovider.upi,
                    paylater:seelctprovider.paylater
        })
    }   
    }


    };

    async loadData() {
        this.setState({ flag: 1 });
        await this.relaodData();
        if (this._isMounted) {
            this.setState({ flag: 2 });
        }
    }

    makeRandomId(length) {
        var result = '';
        var characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }

    async deposit() {
        if (this._isMounted) {
            this.setState({ flag: 4 });
        }
    }

    depositCancel() {
        if (this._isMounted) {
            this.setState({ flag: 2 });
        }
    }


    openPayModal(){
        
        if (this._isMounted) {
            this.setState({
                alert: 0,
                loading:true,
                alertMessage: ''
            });
        }
        //var initamount = this.state.addAmount* 100; 
        var amount = ((this.state.addAmount + (this.state.commission * this.state.addAmount) /100).toFixed(2))* 100;
		var commission = this.state.commission;
        //	alert(initamount+'::'+amount)
        var ProfileUniqeID= this.props.user.ProfileUniqeID;
        var customerId = this.props.user.profileDocId;
        var customerEmail =  this.props.user.EmailId;
        var customerName =  this.props.user.FullName;
        var customerPhone = this.props.user.PhoneNumber;
        var orderNote =  this.state.orderNote?this.state.orderNote:'Direct Payment...';
        var userRole=  this.props.role;
        var receipt = this.props.user.profileDocId + '-D-' + this.makeRandomId(5);
        var firebaseAccessToken = localStorage.getItem('FirebaseToken');
        var that = this;
        let options = {
          "key": RazorpayAPIKey,
          "handler": function(response) {
              if(response.razorpay_order_id){
                if (this._isMounted) {
                    this.setState({
                        loading:true,
                        alert: 0,
                        alertMessage: ''
                    });
                }
                let bodyData = {
                    orderId: response.razorpay_order_id
                };

                RestServices.getRazorPayOrderStatus(bodyData)
                .then((response) => response.json())
                .then(async (responseData) => {
                    let walletBodyData = {
                        customerId: customerId,
                        orderId: response.razorpay_order_id,
                        orderToken: receipt,
                        amount: amount/100,
                        commission : commission,
                        status: 'SUCCESS',
                        type: 'Credit',
                        Description:orderNote,
                        AddedTimeStamp: dateFormatUtil(),
                        UpdatedBy: customerId,
                        EmpID: ProfileUniqeID,
                        userRole: userRole,
                        Provider:'RazorPay',
                        method:responseData.method,
                    };
            
                     RestServices.updateCashFreeWallet(
                        firebaseAccessToken,
                        walletBodyData
                    )
                        .then((response) => response.json())
                        .then((responseData) => {
                            
                            that.relaodData();
                            that.setState({ flag: 2 });
                            
                        })
                        .catch((err) => {
                            if (that._isMounted) {
                                that.setState({
                                    alert: 1,
                                    loading:false,
                                    alertMessage: err.message
                                });
                            }
                        });

                });

              
                } 
              
          },
          "prefill":{
              "name":this.props.user.FullName,
              "email":this.props.user.EmailId,
              "contact":this.props.user.PhoneNumber,
          },
          "notes": {
            "description": orderNote
          },
          "theme": {
            "color": "#528ff0"
          }
        };
        let bodyData = {
            amount: amount,
            receipt: receipt,
            description: orderNote,
            customerId: customerId,
            customerEmail: customerEmail,
            customerName: customerName,
            customerPhone: customerPhone,
            method : this.state.method,
            Provider:'RazorPay'
        };
      RestServices.RazorPayNewOrder(
            firebaseAccessToken,
            bodyData
        )
        .then((response) => response.json())
        .then((responseData) => {
            
        if(responseData.error){
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    loading:false,
                    alertMessage: responseData.error.description?responseData.error.description:responseData.error
                });
            }
        }else{
            if (this._isMounted) {
                this.setState({
                    alert: 0,
                    loading:false,
                    alertMessage: ''
                });
            }

        options.order_id = responseData.id;
        options.amount = responseData.amount;
        
        //console.log(options)
        let walletBodyData = {
            customerId: customerId,
            orderId: responseData.id,
            orderToken: receipt,
            amount: responseData.amount/100,
            commission : commission,
            status: 'PENDING',
            type: 'Credit',
            Description:orderNote,
            AddedTimeStamp: dateFormatUtil(),
            UpdatedBy: customerId,
            EmpID:ProfileUniqeID,
            userRole: userRole,
            Provider:'RazorPay'
        };

        this.updateCashFreeWallet(walletBodyData, false);
        var rzp1 = new window.Razorpay(options);
        rzp1.open();
    }
    })
    .catch((err) => {
        
        if (this._isMounted) {
            this.setState({
                alert: 1,
                loading:false,
                alertMessage: err.message
            });
        }
    });

        
    }

    async makeDepositSubmit() {
        if (this.state.addAmount < 1) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: 'Please add valid amount to deposit'
                });
            }
        }else {
            if(this.state.provider === 'RazorPay'){
                this.openPayModal()
            }
            if(this.state.provider === 'CashFree'){
                this.CashFreeNewOrder()
            }
        }

    }
    

    
    async CashFreeNewOrder() {
        if (this._isMounted) {
            this.setState({
                alert: 0,
                loading:true,
                alertMessage: ''
            });
        }
            var minutesToAdd = 20;
            var currentDate = new Date();
            var futureDate = new Date(
                currentDate.getTime() + minutesToAdd * 60000
            );

            let orderId =
                this.props.user.ProfileUniqeID + '-D-' + this.makeRandomId(5);
            let orderToken =
                this.props.user.ProfileUniqeID + '-D-' + this.makeRandomId(5);
            var amount = ((this.state.addAmount + (this.state.commission * this.state.addAmount) /100).toFixed(2));
		    var commission = this.state.commission;
                
            let bodyData = {
                customerId: this.props.user.profileDocId,
                customerEmail: this.props.user.EmailId,
                customerName: this.props.user.FullName,
                customerPhone: this.props.user.PhoneNumber,
                returnUrl:
                    'https://' +
                    window.location.host +
                    '/deposite-confirmation?order_id={order_id}&order_token={order_token}',
                orderId: orderId,
                orderAmount: amount,
                orderNote: this.state.orderNote?this.state.orderNote:'Direct Payment...',
                paymentMethod: this.state.method, //app
                orderExpiryTime: futureDate.toISOString(),
                Provider:'CashFree'
            };
            await RestServices.getPaymentLink(
                localStorage.getItem('FirebaseToken'),
                bodyData
            )
                .then((response) => response.json())
                .then((responseData) => {
                    
                    if (responseData.payment_link) {
                        let walletBodyData = {
                            customerId: this.props.user.profileDocId,
                            orderId: orderId,
                            orderToken: orderToken,
                            amount: responseData.order_amount,
                            commission: commission,
                            status: 'PENDING',
                            type: 'Credit',
                            Description:this.state.orderNote,
                            AddedTimeStamp: dateFormatUtil(),
                            UpdatedBy: this.props.user.profileDocId,
                            EmpID:this.props.user.ProfileUniqeID,
                            userRole: this.props.role,
                            method : this.state.method, 
                            Provider:'CashFree'
                            
                        };
                        

                        this.updateCashFreeWallet(walletBodyData, true);
                        window.location.href = responseData.payment_link;
                        if (this._isMounted) {
                            this.setState({ flag: 2, alert: 0 });
                        }
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                flag: 4,
                                alert: 1,
                                loading:false,
                                alertMessage: responseData.message?responseData.message:responseData.error
                            });
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: 4,
                            alert: 1,
                            loading:false,
                            alertMessage: err.message
                        });
                    }
                });
        
    }

    


    copyToClipboard = (rowData, FlashMessageString) => {
        
        var textField = document.createElement('textarea');
        textField.innerText = rowData.linkURL;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        if (this._isMounted) {
            this.setState({
                ShowFlashMessage: true,
                FlashMessage: FlashMessageString
            });
            setTimeout(() => {
                this.setState({ ShowFlashMessage: false, FlashMessage: '' });
            }, 5000);
        }
    };

    render() {
        

        return (
            <div>
                {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}

                {this.state.flag === 1 && <Spinner animation="border" />}
                {this.state.loading && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 2 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 5 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                <Row
                    style={{
                        marginBottom: '1rem',
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: 'row',
                        textAlign: 'left'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '0.5rem'
                        }}
                    >
                        <p></p>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '0.5rem'
                        }}
                    >
                        <p>
                            Wallet Balance: ₹{' '}
                            {parseFloat(this.state.currentTotalBalance).toFixed(2)}
                        </p>
                        <Button
                            variant="primary"
                            onClick={() => this.deposit()}
                        >
                            Deposit
                        </Button>
                    </div>
                </Row>

                {this.state.flag === 4 && (
                    <div>
                        <Row>
                        <Col>
                            <h5>Virtual Accounts</h5>
                            <p>Please contact admin to update Virtual Accounts Details</p>
                            <hr />
                        </Col>
                       </Row>
                

                {this.state.virtualAccounts &&<div>
                                    <Form.Row style={{ width: '30%' }}>
                                        <Form.Group as={Col}>
                                        <Form.Label>
                                        UPI Address
                                        </Form.Label>
                                        <Form.Control
                                        disabled
                                        value={this.state.virtualAccounts.UPIAddress}
                                        type="text"
                                        />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row style={{ width: '3%',padding: '0' }}>
                                        {this.state.virtualAccounts.UPIAddress &&<img onClick={(e) =>
                                            this.copyToClipboard(
                                                this.state.virtualAccounts.UPIAddress,
                                                'UPIAddress copied to clipboard'
                                            )
                                        }className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                    </Form.Row>

                                    <Form.Row style={{ width: '30%' }}>
                                        <Form.Group as={Col}>
                                        <Form.Label>
                                        IFSC
                                        </Form.Label>
                                        <Form.Control
                                        disabled
                                        value={this.state.virtualAccounts.IFSC}
                                        type="text"
                                        />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row style={{ width: '3%',padding: '0' }}>
                                        {this.state.virtualAccounts.IFSC &&<img onClick={(e) =>
                                            this.copyToClipboard(
                                                this.state.virtualAccounts.IFSC,
                                                'IFSC copied to clipboard'
                                            )
                                        }className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                    </Form.Row>


                                    <Form.Row style={{ width: '30%' }}>
                                        <Form.Group as={Col}>
                                        <Form.Label>Account #</Form.Label>
                                        <Form.Control
                                        disabled
                                        value={this.state.virtualAccounts.AccountNumber}
                                        type="text"
                                        />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row style={{ width: '3%',padding: '0' }}>
                                        {this.state.virtualAccounts.AccountNumber &&<img onClick={(e) =>
                                            this.copyToClipboard(
                                                this.state.virtualAccounts.AccountNumber,
                                                'AccountNumber copied to clipboard'
                                            )
                                        }className="copy_icon" src={'copy-svgrepo-com.svg'} />}
                                    </Form.Row>
                                </div>}
                                <Row>
                        <Col>
                            <hr />
                        </Col>
                       </Row>

                        <Form.Row>
					    <Form.Group as={Col}>
                            <Form.Label>Enter Amount to Deposit</Form.Label>
                            <Form.Control
                                value={this.state.addAmount}
                                onChange={this.onChangeValues}
                                name="addAmount"
                                type="number"
                                placeholder="Enter Amount"
                            />
                        </Form.Group>
                        </Form.Row>
                        
                        <Form.Row>
					    <Form.Group as={Col}>
                            
                            <Form.Label>Select Provider</Form.Label>
                                  <select
                                        className="form-control"
                                        style={{ width: '100%' }}
                                        name="provider"
                                        onChange={this.onChangeValues}
                                        value={this.state.provider}
                                    >
                                        <option
                                                key="0"
                                                value=""
                                            >
                                               Select Payment Gateway
                                            </option>
                                            {this.state.providerOptions.map((option) => (
                                            <option
                                                key={option.title}
                                                value={option.title}
                                            >
                                               {option.title}
                                            </option>
                                        ))}
                                        
                                            
                                        
                                    </select>

                        </Form.Group>
                        </Form.Row>
                        
                        <Form.Row>
					    <Form.Group as={Col}>
                            <Form.Label>Payment modes</Form.Label>
                                    <select
                                        className="form-control"
                                        style={{ width: '100%' }}
                                        name="method"
                                        onChange={this.onChangeValues}
                                        value={this.state.method}
                                    >
                                            <option key='' value='' >
                                            Please select...
                                            </option>
                                            {parseFloat(this.state.card) >0 &&<option key='card' value='card' >
                                            Card (Visa, MasterCard, RuPay and Maestro) @{this.state.card}% Commission
                                            </option>}
                                            {parseFloat(this.state.upi) >0 &&<option key='upi' value='upi' >
                                            UPI/QR (Google,PayTM and More) @{this.state.upi}% Commission
                                            </option>}
                                            {parseFloat(this.state.netbanking) >0 &&<option key='netbanking' value='netbanking' >
                                            Netbanking (All Indian banks) @{this.state.netbanking}% Commission
                                            </option>}
                                            {parseFloat(this.state.wallet) > 0 &&<option key='wallet' value='wallet' >
                                            Wallet (PhonePe and More) @{this.state.wallet}% Commission
                                            </option>}
                                            {parseFloat(this.state.emi) > 0 && <option key='emi' value='emi' >
                                            EMI @{this.state.emi}% Commission
                                            </option>}
                                        
                                    </select>
                                    

                        </Form.Group>
                        </Form.Row>

                        <Form.Row>
					    <Form.Group as={Col}>
                            <Form.Label>Enter Notes (optional)</Form.Label>
                            <Form.Control
                                value={this.state.orderNote}
                                onChange={this.onChangeValues}
                                name="orderNote"
                                type="text"
                                placeholder="Enter Note"
                            />
                        </Form.Group>
                        </Form.Row>

                        

                        <Form.Group>
                            <Button
                                onClick={() => {
                                    this.depositCancel();
                                }}
                                style={{ marginTop: '0.3rem' }}
                            >
                                Cancel
                            </Button>
                            {!this.state.loading &&<Button
                                onClick={() => {
                                    this.makeDepositSubmit();
                                }}
                                style={{
                                    marginLeft: '0.5rem',
                                    marginTop: '0.3rem'
                                }}
                            >
                                Submit
                            </Button>}
                        </Form.Group>
                    </div>
                )}

                {this.state.flag === 2 && (
                    <div>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>

                                    {this.state.search_by =='status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by =='Date' &&<Form.Control
                                        placeholder="Select Date"
                                        type="date"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        
                                    />}

                                    {this.state.search_by !=='status' && this.state.search_by !=='Date' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                        <MaterialTable
                            title="Transactions"
                            columns={getColumns()}
                            data={this.state.data}
                            options={{
                                exportButton: {
                                    csv: true
                                },
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1,
                                
                            }}
                        />
                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
                {this.state.alert === 11 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(TransactionHistory);
